var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex h-full w-full items-center ju"},[_c('video',{ref:"videoPlayer",staticClass:"video-js"},[(_vm.source)?_c('source',{attrs:{"type":"video/mp4","src":_vm.source}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }